import { useState } from 'react';
import produce from 'immer';
import { message } from 'antd';
import useAsyncEffect from 'src/hooks/useAsyncEffect';
import TreeNodeProps from '../../types/TreeNodeProps';
// TODO: [UI-2526] Request to hide options except SKUs
// import LookupCategories from '../../types/LookupCategories';
// import { getLookupCategories, getLookupCustomFilters } from '../../services/productAssociation.service';
import {
  SourceOwnerDataItem,
  ManufacturersDataItem,
  getSourceOwner,
  getManufacturers,
} from '../../api/productAssociation.api';

export type LookupOptionsData = {
  loading: boolean;
  manufacturerName: string;
  sourceSites: SourceOwnerDataItem[];
  currentSourceSite?: string;
  categoriesData: TreeNodeProps[];
  customFiltersData: TreeNodeProps[];
  manufacturersData: ManufacturersDataItem[];
};

export const useLookupOptionsFetch = () => {
  const [state, setState] = useState<LookupOptionsData>({
    loading: false,
    manufacturerName: '',
    sourceSites: [],
    currentSourceSite: undefined,
    categoriesData: [],
    customFiltersData: [],
    manufacturersData: [],
  });

  const mergeState = (fn: (draft: LookupOptionsData) => void) => {
    setState(produce(fn));
  };

  const setLoading = (loading: boolean) => {
    mergeState((draft: LookupOptionsData) => {
      draft.loading = loading;
    });
  };

  const setManufacturerName = (name: string) => {
    mergeState((draft: LookupOptionsData) => {
      draft.manufacturerName = name;
    });
  };

  const setSourceSites = (sourceSites: SourceOwnerDataItem[]) => {
    mergeState((draft: LookupOptionsData) => {
      draft.sourceSites = sourceSites;
    });
  };

  const setCurrentSourceSite = (sourceSite: string) => {
    mergeState((draft: LookupOptionsData) => {
      draft.currentSourceSite = sourceSite;
    });
  };
  // TODO: [UI-2526] Request to hide options except SKUs

  // const setCategoriesData = (categories: LookupCategories.CategoryItem[]) => {
  //   mergeState((draft: LookupOptionsData) => {
  //     draft.categoriesData = categories;
  //   });
  // };

  // const setCustomFiltersData = (customFilters: TreeNodeProps[]) => {
  //   mergeState((draft: LookupOptionsData) => {
  //     draft.customFiltersData = customFilters;
  //   });
  // };

  const setManufacturersData = (manufacturers: ManufacturersDataItem[]) => {
    mergeState((draft: LookupOptionsData) => {
      draft.manufacturersData = manufacturers;
    });
  };

  useAsyncEffect(async () => {
    setLoading(true);
    try {
      const { sourceOwner } = await getSourceOwner();
      if (sourceOwner) {
        setSourceSites(sourceOwner);
      }
    } catch {
      message.error('There was an error while loading Source sites.');
    }
    setLoading(false);
  }, []);

  useAsyncEffect(async () => {
    // TODO: [UI-2526] Request to hide options except SKUs
    // if (state.currentSourceSite) {
    //   setLoading(true);
    //   const categoriesPromise = getLookupCategories({ sourceOwnerId: state.currentSourceSite });
    //   const customFiltersPromise = getLookupCustomFilters({ sourceOwnerId: state.currentSourceSite });
    //   try {
    //     setCategoriesData(await categoriesPromise);
    //   } catch {
    //     message.error('Categories weren`t loaded.');
    //   }
    //   try {
    //     setCustomFiltersData(await customFiltersPromise);
    //   } catch {
    //     message.error('Custom Filters weren`t loaded.');
    //   }
    //   setLoading(false);
    // }
  }, [state.currentSourceSite]);

  useAsyncEffect(async () => {
    if (state.manufacturerName && state.currentSourceSite) {
      setLoading(true);
      try {
        const { manufacturers } = await getManufacturers({
          ownerId: state.currentSourceSite,
          manufacturer: state.manufacturerName,
        });
        setManufacturersData(manufacturers);
      } catch {
        message.error('Manufacturers weren`t loaded.');
      }
      setLoading(false);
    }
  }, [state.currentSourceSite, state.manufacturerName]);

  return { lookupOptionsData: state, setManufacturerName, setCurrentSourceSite };
};
